import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);

// Initialize database - create tables if they don't exist
export async function initializeDatabase() {
  try {
    // Initialize contact_submissions table
    await initializeTable('contact_submissions', 'create_contact_table');
    
    // Initialize article_feedback table
    await initializeTable('article_feedback', 'create_article_feedback_table');
    
    return { success: true };
  } catch (error) {
    console.error('Error initializing database:', error);
    return { success: false, error };
  }
}

// Helper function to initialize a specific table
async function initializeTable(tableName: string, rpcFunctionName: string) {
  // First, check if the table already exists
  const { data: tableExists, error: tableCheckError } = await supabase
    .from(tableName)
    .select('id')
    .limit(1);
  
  // If the table exists, we don't need to create it
  if (!tableCheckError || tableExists) {
    return { success: true };
  }
  
  // Method 1: Use a stored procedure if it exists
  const { error: rpcError } = await supabase.rpc(rpcFunctionName, {});
  
  if (!rpcError) {
    return { success: true };
  }
  
  // Method 2: Use the SQL from supabase-setup.sql file
  return { 
    success: false, 
    error: 'Could not auto-create table',
    manual_instructions: 'Please create the table in Supabase dashboard using the SQL in src/services/supabase-setup.sql'
  };
} 